export default "__VITE_ASSET__BX_oRH3I__"